import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { GetOvertimeByPayrollResultId } from '../../../../../../../reduxToolkit/PayrollPolicy/PayrollPolicyApi';
import { IconGraphGrowth } from '../../../../../../../components/buttons/IconButtons';
import { colors } from '../../../../../../../enums/colors';
import PayrollLinesColumn, { PayrollLineRow, getWidestAmount } from './PayrollLinesColumn';
import {POLICY_CONDITION_MODEL} from "../../../OvertimePolicies/Global/CreateUpdatePolicy/Model/Model";
import { getOvertimeBreakdown } from '../Model/Model';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const PerceptionsAssignedSection = ({ id, row }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [lines, setLines] = useState([]);

    useEffect(() => {
        if (!id) return;
        dispatch(GetOvertimeByPayrollResultId(id)).then(({ payload: { data: { data, success } } }) => {
            if (success) setLines(data ?? []);
        });
    }, [id]);

    // Base salary is shown as a leading row, so it counts toward the column total.
    const total = lines.reduce((sum, item) => sum + (item?.result ?? 0), 0) + (row?.baseSalary ?? 0);
    const widest = getWidestAmount(lines, 'result', total);

    return (
        <div className='row'>
            <PayrollLinesColumn
                title={t('perceptions')}
                lines={lines}
                getName={(item) => item.policyNameSnapshot}
                getAmount={(item) => item.result}
                widest={widest}
                total={total}
                titleIcon={<IconGraphGrowth fill={colors.secondary700}/>}
                chipColors={{ background: colors.secondary100, fontColor: colors.secondary700, borderColor: colors.secondary150 }}
                className='col-12 px-1'
                getLegend={(item) => POLICY_CONDITION_MODEL[item?.policyConditionSnapshot]?.legend(
                    item?.totalOvertimeMinutes,
                    item?.policyCalculationTypeSnapshot,
                    item.policyCalculationValueSnapshot
                )}
                getBreakdown={(item) => getOvertimeBreakdown(item, row)}
                leadingRow={row?.baseSalary != null &&
                    <PayrollLineRow
                        name={t('base_salary')}
                        amount={row?.baseSalary}
                        widest={widest}
                        legend={t('payment_an_employee_receives_for_their_regular_working_hours')}
                        leadingRow={true}
                        breakdown={row}
                    />
                }
            />
        </div>
    );
};

export default PerceptionsAssignedSection;
